import {create, StateCreator, StoreApi, UseBoundStore} from "zustand";
import {devtools} from "zustand/middleware";
import {areWeTestingWithJest, isDevEnv} from "@buildwithflux/shared";

/**
 * State interface for the Copilot Execution Plan store
 */
export interface CopilotExecutionPlanState {
    // UI state
    isExpanded: boolean;

    // Actions
    onExpand(): void;
    onCollapse(): void;
    setIsExpanded(expanded: boolean): void;
}

/**
 * Store type for the Copilot Execution Plan
 */
export type UseCopilotExecutionPlanStore = UseBoundStore<StoreApi<CopilotExecutionPlanState>>;

/**
 * Factory function to create the Copilot Execution Plan store
 */
export function createCopilotExecutionPlanStore(): UseCopilotExecutionPlanStore {
    const storeConfig: StateCreator<CopilotExecutionPlanState> = (set) => ({
        // Initial state
        isExpanded: false,

        // Action implementations
        onExpand() {
            set(
                (state): CopilotExecutionPlanState => ({
                    ...state,
                    isExpanded: true,
                }),
            );
        },

        onCollapse() {
            set(
                (state): CopilotExecutionPlanState => ({
                    ...state,
                    isExpanded: false,
                }),
            );
        },

        setIsExpanded(expanded: boolean) {
            set(
                (state): CopilotExecutionPlanState => ({
                    ...state,
                    isExpanded: expanded,
                }),
            );
        },
    });

    return create<CopilotExecutionPlanState>()(
        devtools(storeConfig, {
            enabled: isDevEnv() && !areWeTestingWithJest(),
            name: "CopilotExecutionPlanStore",
        }),
    );
}
